"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PrintStream = _interopRequireDefault(require("../../../../java/io/PrintStream"));

var _StringReader = _interopRequireDefault(require("../../../../java/io/StringReader"));

var _DecimalFormat = _interopRequireDefault(require("../../../../java/text/DecimalFormat"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _ByteArrayOutputStream = _interopRequireDefault(require("../../../../java/io/ByteArrayOutputStream"));

var _Assert = _interopRequireDefault(require("./Assert"));

var _IOException = _interopRequireDefault(require("../../../../java/io/IOException"));

var _LineNumberReader = _interopRequireDefault(require("../../../../java/io/LineNumberReader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StringUtil =
/*#__PURE__*/
function () {
  function StringUtil() {
    _classCallCheck(this, StringUtil);

    StringUtil.constructor_.apply(this, arguments);
  }

  _createClass(StringUtil, [{
    key: "getClass",
    value: function getClass() {
      return StringUtil;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "chars",
    value: function chars(c, n) {
      var ch = new Array(n).fill(null);

      for (var i = 0; i < n; i++) {
        ch[i] = c;
      }

      return new String(ch);
    }
  }, {
    key: "getStackTrace",
    value: function getStackTrace() {
      if (arguments.length === 1) {
        var t = arguments[0];
        var os = new _ByteArrayOutputStream.default();
        var ps = new _PrintStream.default(os);
        t.printStackTrace(ps);
        return os.toString();
      } else if (arguments.length === 2) {
        var _t = arguments[0],
            depth = arguments[1];
        var stackTrace = "";
        var stringReader = new _StringReader.default(StringUtil.getStackTrace(_t));
        var lineNumberReader = new _LineNumberReader.default(stringReader);

        for (var i = 0; i < depth; i++) {
          try {
            stackTrace += lineNumberReader.readLine() + StringUtil.NEWLINE;
          } catch (e) {
            if (e instanceof _IOException.default) {
              _Assert.default.shouldNeverReachHere();
            } else throw e;
          } finally {}
        }

        return stackTrace;
      }
    }
  }, {
    key: "split",
    value: function split(s, separator) {
      var separatorlen = separator.length;
      var tokenList = new _ArrayList.default();
      var tmpString = "" + s;
      var pos = tmpString.indexOf(separator);

      while (pos >= 0) {
        var token = tmpString.substring(0, pos);
        tokenList.add(token);
        tmpString = tmpString.substring(pos + separatorlen);
        pos = tmpString.indexOf(separator);
      }

      if (tmpString.length > 0) tokenList.add(tmpString);
      var res = new Array(tokenList.size()).fill(null);

      for (var i = 0; i < res.length; i++) {
        res[i] = tokenList.get(i);
      }

      return res;
    }
  }, {
    key: "toString",
    value: function toString() {
      if (arguments.length === 1 && typeof arguments[0] === "number") {
        var d = arguments[0];
        return StringUtil.SIMPLE_ORDINATE_FORMAT.format(d);
      }
    }
  }, {
    key: "spaces",
    value: function spaces(n) {
      return StringUtil.chars(' ', n);
    }
  }]);

  return StringUtil;
}();

exports.default = StringUtil;

StringUtil.constructor_ = function () {};

StringUtil.NEWLINE = _System.default.getProperty("line.separator");
StringUtil.SIMPLE_ORDINATE_FORMAT = new _DecimalFormat.default("0.#");